/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable import/no-cycle */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-console */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
// IMPORTS
import { jwtDecode } from 'jwt-decode'
import axios from 'axios'
import * as Auth from 'aws-amplify/auth'
import { parseString } from 'xml2js'
import * as FullStory from '@fullstory/browser'

import { setUserContext, sendDatadogError } from '../../../services/datadog'
import { registerApps, unregisterApp } from '../../../../../registerApps'

import { parseDateForUI, parseCreatedForUI, generateUUID } from '../../../services/utils'

import darkly from '../../../services/darkly'
import { getDarklyFlags } from './selectors/darklySelectors'
import { isVisionVisible } from './selectors/organizationsSelectors'
import { getAuthFederatedLogin, getAuth } from '../../Auth/services/authSelectors'
import { setToken } from '../../Auth/services/actions'
import { sanitizeContent, transformServicesArrayToObj } from '../../../../../utils'
import { mapDataset, mapIntegrationStream } from '../scenes/DataIntegrationsNew/utils'

import {
  checkOrgHasScores,
  loadOnboardingChecks,
  setCompletedStep,
  checkOrgHasCampaigns
} from './actions/onboardingActions'
import { INTEGRATION_STREAMS_LOADER } from './actions/integrationActions'

export const groupTypeLabelMap = {
  Static: 'Manual',
  'Criteria Filled by Rule': 'Criteria Filled by Risk Response Rule',
  Dynamic: 'Dynamic'
}

// ACTIONS
// auth
export const LOGOUT = 'LOGOUT'
// admin
export const WHO_AM_I = 'WHO_AM_I'
export const SET_ADMINS = 'SET_ADMINS'
export const DELETE_ADMIN = 'DELETE_ADMIN'
export const SEND_INVITATION = 'SEND_INVITATION'
export const SET_SIMPLE_EMPLOYEES_COUNT = 'SET_SIMPLE_EMPLOYEES_COUNT'
export const SET_LOADING_ADMINS = 'SET_LOADING_ADMINS'
// orgs
export const SET_COMPANY = 'SET_COMPANY'
export const CLEAN_ORG_AUTH_SETTINGS = 'CLEAN_ORG_AUTH_SETTINGS'
export const SET_ORG_SENDER_SIGNATURE_STATUS = 'SET_ORG_SENDER_SIGNATURE_STATUS'
export const SET_ORG_AUTH_SETTINGS = 'SET_ORG_AUTH_SETTINGS'
export const SET_SERVICES = 'SET_SERVICES'
export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS'
export const CREATE_ORGANIZATION = 'CREATE_ORGANIZATION'
export const EDIT_ORGANIZATION = 'EDIT_ORGANIZATION'
export const SET_API_KEY = 'SET_API_KEY'
export const SET_API_KEYS = 'SET_API_KEYS'
export const DELETE_API_KEY = 'DELETE_API_KEY'
export const REVEAL_API_KEY = 'REVEAL_API_KEY'
export const UPDATE_API_KEY = 'UPDATE_API_KEY'
export const SET_NEWLY_CREATED_API_KEY = 'SET_NEWLY_CREATED_API_KEY'
export const SET_HAS_BEHAVIOR_DATA = 'SET_HAS_BEHAVIOR_DATA'
export const SET_GENERATE_KEY_LOADER = 'SET_GENERATE_KEY_LOADER'
// users
export const SET_EMPLOYEES = 'SET_EMPLOYEES'
export const SET_EMPLOYEE_COUNT = 'SET_EMPLOYEE_COUNT'
export const SET_MANAGER_COUNT = 'SET_MANAGER_COUNT'
export const SET_LAST_UPLOAD_DATE = 'SET_LAST_UPLOAD_DATE'
export const SET_RECORDS_CHANGED_COUNT = 'SET_RECORDS_CHANGED_COUNT'
// integrations
export const SET_INTEGRATION_TYPES = 'SET_INTEGRATION_TYPES'
export const SET_ENABLED_INTEGRATIONS = 'SET_ENABLED_INTEGRATIONS'
export const SET_CONNECTORS = 'SET_CONNECTORS'
export const SET_INTEGRATION_STREAMS = 'SET_INTEGRATION_STREAMS'
export const SET_S3_UPLOAD_PROGRESS = 'SET_S3_UPLOAD_PROGRESS'
// campaigns
export const RESET_CAMPAIGNS_LOADED = 'RESET_CAMPAIGNS_LOADED'
export const SET_CAMPAIGNS = 'SET_CAMPAIGNS'
export const SET_CAMPAIGN_SESSIONS = 'SET_CAMPAIGN_SESSIONS'
export const SET_CAMPAIGN_SESSION = 'SET_CAMPAIGN_SESSION'
export const SET_CAMPAIGN_TARGETS = 'SET_CAMPAIGN_TARGETS'
export const SET_CAMPAIGN_LEADS = 'SET_CAMPAIGN_LEADS'
export const SET_CAMPAIGN_ROOMS = 'SET_CAMPAIGN_ROOMS'
export const ADD_CAMPAIGN_ROOM = 'ADD_CAMPAIGN_ROOM'
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN'
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN'
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN'
export const SET_CAMPAIGN_INFO = 'SET_CAMPAIGN_INFO'
// templates
export const SET_TEMPLATES = 'SET_TEMPLATES'
// groups
export const SET_GROUPS = 'SET_GROUPS'
export const CLEAR_GROUPS = 'CLEAR_GROUPS'
export const SET_GROUP = 'SET_GROUP'
export const UPDATE_GROUP = 'UPDATE_GROUP'
export const SET_GROUP_MEMBERS = 'SET_GROUP_MEMBERS'
export const SET_GROUP_MEMBERSHIP_DATA = 'SET_GROUP_MEMBERSHIP_DATA'
export const SET_GROUP_MEMBERSHIP_LOGS = 'SET_GROUP_MEMBERSHIP_LOGS'
export const SET_GROUP_POLICY_DATA = 'SET_GROUP_POLICY_DATA'
export const SET_GROUP_MEMBERS_FILTERS = 'SET_GROUP_MEMBERS_FILTERS'
export const SET_DEFAULT_GROUPS = 'SET_DEFAULT_GROUPS'
export const SET_DEFAULT_GROUP_MEMBERS = 'SET_DEFAULT_GROUP_MEMBERS'
export const DELETE_GROUP = 'DELETE_GROUP'
export const GROUPS_LOADED = 'GROUPS_LOADED'
export const LOADING_GROUPS_FILTERS = 'LOADING_GROUPS_FILTERS'
export const SET_AVAILABLE_FILTERS = 'SET_AVAILABLE_FILTERS'
// preferred languages
export const SET_PREFERRED_LANGUAGES = 'SET_PREFERRED_LANGUAGES'
// messages
export const NEW_MESSAGE = 'NEW_MESSAGE'
export const EXPIRE_MESSAGE = 'EXPIRE_MESSAGE'
export const CLEAR_ALL_MESSAGE = 'CLEAR_ALL_MESSAGE'
export const FILTER_MESSAGE = 'FILTER_MESSAGE'
// typeahead
export const SET_TYPEAHEAD_RESULTS = 'SET_TYPEAHEAD_RESULTS'
export const SET_TYPEAHEAD_LOADING = 'SET_TYPEAHEAD_LOADING'
export const INIT_TYPEAHEAD = 'INIT_TYPEAHEAD'
// On boarding
export const SET_ONBOARDING_CHECKS = 'SET_ONBOARDING_CHECKS'
// Darkly
export const DARKLY_SET_FLAGS = 'DARKLY_SET_FLAGS'

// CONSTANTS
const REFRESH_WINDOW = 60

const GROUP_CATEGORIES = {
  1: 'locations',
  2: 'departments'
}

const GROUP_TYPES = {
  2: 'custom'
}

// ACTION CREATORS

/** **************** DARKLY ***************** */
export function setFlags(flags) {
  return {
    type: DARKLY_SET_FLAGS,
    data: flags
  }
}

/** **************** AUTH ***************** */

export function logout(errorEvent, { preventAutoLogin = false, reload = true } = {}) {
  return (dispatch) => {
    // AmplifyAuth.signOut() has a bad side effect: it redirects to Cognito to signOut then back to EP,
    // so for now we clear the localStorage
    Object.entries(localStorage)
      .map((entry) => entry[0])
      .filter((key) =>
        startsWithAnyIgnoreCase(key, [
          'COGNITO',
          'AMPLIFY',
          'COMPANY',
          'JWT',
          'managerToken',
          'managerSaved',
          'impersonate_es_person_id'
        ])
      )
      .forEach((key) => {
        localStorage.removeItem(key)
      })
    const errorMessage = []
    if (errorEvent && 'detail' in errorEvent) {
      let details = errorEvent.detail
      try {
        details = getErrorMessage(details)
        if (details) {
          errorMessage.push(details)
        }
      } catch (err) {
        // Regular log out (no error)
      }
    }
    dispatch({
      type: LOGOUT,
      data: { preventAutoLogin },
      error: errorMessage
    })

    if (reload) {
      window.location.reload()
    }

    // Unregister vision2 and pulse app so that it does not render under the Auth login page.
    unregisterApp({ appName: 'vision2' })
    unregisterApp({ appName: 'pulse' })
    unregisterApp({ appName: 'hackersmind' })
    unregisterApp({ appName: 'reflex' })
  }

  function getErrorMessage(details) {
    if (details.toUpperCase() === 'INVALID TOKEN') {
      return `Authentication Failed. Please refresh the page and try again (${details})`
    }
    if (details.toUpperCase() === 'INACTIVITY_LOGOUT') {
      return "We've logged you out after an extended period of inactivity"
    }
    return `An error occurred: "${details}".
      Please verify that you have used the correct email address, try again, and reach out to Support if the problem persists.`
  }

  function startsWithAnyIgnoreCase(str, prefixes) {
    const stringToCompare = str.toUpperCase()
    return prefixes.some((p) => stringToCompare.startsWith(p.toUpperCase()))
  }
}

export function initializeEP() {
  return (dispatch, getState) => {
    dispatch(getCompany())
  }
}

export function isLoading(isLoading) {
  return (dispatch) => {
    dispatch({
      type: SET_GENERATE_KEY_LOADER,
      data: isLoading
    })
  }
}

export function checkToken() {
  return async (dispatch, getState) => {
    let token = getAuth(getState()).get('JWT')
    if (!token) {
      throw new Error()
    }
    const now = Date.now() / 1000
    const expiration = jwtDecode(token).exp
    const is_token_expired = expiration < now

    if (!is_token_expired) {
      return dispatch(setToken({ token }))
    }

    try {
      setRedirectUrl()
      token = await refreshToken()
      localStorage.removeItem('redirectUrl', window.location.pathname)
      return dispatch(setToken({ token }))
    } catch (err) {
      sendDatadogError(err)
      return dispatch(
        logout({ detail: 'An Error occurred during authentication. Please try again later.' })
      )
    }
  }
}

export async function refreshToken() {
  console.log('start refreshToken')
  const session = await Auth.fetchAuthSession()
  console.log('end refreshToken')
  return `Bearer ${session.tokens.idToken}`
}

export function setRedirectUrl() {
  const url = window.location
  if (url.href.includes('?admin') && url.pathname !== '/engagement') {
    localStorage.setItem('redirectUrl', window.location.pathname)
  }
}
/** **************** ADMIN ***************** */
export function whoAmI() {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: '/employee/me/',
      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: WHO_AM_I,
          data: { ...res.data }
        })
        // Set indentity of the logged in user in Launchdarkly
        const organization = getState().get('engagement').orgs.get('company').shortname
        const user = {
          key: res.data.id,
          email: res.data.email,
          custom: {
            is_staff: res.data.is_staff,
            organization
          }
        }
        darkly.identify(user)

        /**
         * Identify user in FullStory
         */
        const { initFullStory } = getDarklyFlags(getState())

        if (initFullStory) {
          FullStory.identify(res.data.id, {
            email: res.data.email,
            organization,
            displayName: res.data.full_name
          })
        }

        dispatch(setUserContext())
        return res.data
      })
      .catch((res) => {
        dispatch({
          type: LOGOUT
        })
      })
  }
}

export function editProfile(first_name, last_name, email) {
  return async (dispatch, getState) => {
    email = email.toLowerCase()
    const token = getState().get('engagement').auth.get('JWT')
    const isFederatedLogin = getAuthFederatedLogin(getState())

    try {
      if (!isFederatedLogin) {
        const attributes = await Auth.fetchUserAttributes()
        const currentEmailAttr = attributes.email
        const currentEmail = currentEmailAttr || null
        if (currentEmail !== email) {
          await Auth.updateUserAttributes({ userAttributes: { email } })
        }
      }
      await axios({
        method: 'patch',
        url: '/employee/me/',

        headers: {
          Authorization: token
        },
        data: { first_name, last_name, email }
      })
      dispatch(whoAmI())
      dispatch(getAdmins())
      dispatch(
        createMessage(
          {
            type: 'generic',
            level: 'success',
            header: 'Success!',
            content: 'Admin profile updated.'
          },
          8000
        )
      )
    } catch (err) {
      const messageData = {
        type: 'generic',
        level: 'danger',
        header: 'Error:'
      }

      messageData.content =
        err.message ||
        (err.response && err.response.data
          ? err.response.data[Object.keys(err.response.data)[0]]
          : 'Profile could not be updated.')

      dispatch(createMessage(messageData, 8000))
    }
  }
}
export function changePassword(current_password, new_password, cb) {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    try {
      const rest = await Auth.updatePassword({
        oldPassword: current_password,
        newPassword: new_password
      })
      if (cb) cb(true)
      dispatch(
        createMessage(
          {
            type: 'generic',
            level: 'success',
            header: 'Success!',
            content: 'Admin password has been changed.'
          },
          8000
        )
      )
    } catch (err) {
      if (cb) cb(false)
      const messageData = {
        type: 'generic',
        level: 'danger',
        header: 'Error:',
        content: 'Password not changed.'
      }
      if (err.message) {
        messageData.content = err.message
      }
      dispatch(createMessage(messageData, 8000))
    }
  }
}

export function getAdmins() {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    dispatch({
      type: SET_LOADING_ADMINS,
      data: true
    })

    return axios({
      method: 'get',
      url: `/employees/?organization=${orgId}&is_active=true&is_admin=true&ordering=first_name&exclude_internal_admins=true`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_ADMINS,
          data: res.data
        })
        dispatch({
          type: SET_LOADING_ADMINS,
          data: false
        })
      })
      .catch((err) => {
        dispatch({
          type: SET_LOADING_ADMINS,
          data: false
        })
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve admins.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

/**
 * getSimpleEmployees dispatch the number of employees
 * that are not admins
 */
export function getSimpleEmployees() {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')
    return axios({
      method: 'get',
      url: `/employees/?organization=${orgId}&limit=1&is_admin=false`,

      headers: {
        Authorization: `${token}`
      }
    }).then((res) => {
      const { count } = res.data
      dispatch({
        type: SET_SIMPLE_EMPLOYEES_COUNT,
        data: count
      })
    })
  }
}

export function addAdmin(employeeId, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'patch',
      url: `/employees/${employeeId}/`,

      headers: {
        Authorization: token
      },
      data: { is_admin: true, es_role: 'admin' }
    })
      .then((res) => {
        const name = `${res.data.first_name} ${res.data.last_name}`
        if (cb) cb()
        dispatch(getAdmins())
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `${sanitizeContent(name)} added as admin.`
            },
            8000
          )
        )
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not add admin.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function deleteAdmin({ id }) {
  return (dispatch, getState) => {
    const adminCount = getState().get('engagement').admin.get('count')

    if (adminCount > 1) {
      const token = getState().get('engagement').auth.get('JWT')

      return axios({
        method: 'patch',
        url: `/employees/${id}/`,
        headers: {
          Authorization: token
        },
        data: { is_admin: false, es_role: 'no_access' }
      })
        .then((res) => {
          dispatch(getAdmins())
        })
        .catch((err) => {
          dispatch(
            createMessage(
              {
                type: 'generic',
                level: 'danger',
                header: 'Error:',
                content: 'Could not delete admin.'
              },
              8000
            )
          )
          console.error(err)
        })
    }
    dispatch(
      createMessage(
        {
          type: 'generic',
          level: 'danger',
          header: 'Deletion error:',
          content: `Must have at least one admin.`
        },
        8000
      )
    )
  }
}

/** **************** ORGS ***************** */
export function getCompany() {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: '/organizations/current/',
      headers: {
        Authorization: token
      }
    })
      .then(async (res) => {
        const {
          id,
          name,
          industry,
          security_email,
          sender_name,
          sender_email,
          phishing_report_email,
          default_timezone,
          shortname,
          token_expiration,
          legacy_token_expiration,
          metadata,
          services,
          bundle_name,
          bundle,
          organization_type,
          onboarding_survey_completed,
          last_employee_changes_count,
          enable_hm_short_demo,
          onboarding_steps_finished,
          created,
          plan,
          plan_state,
          plan_state_expiration_date,
          salesforce_id
        } = res.data

        const show_ui_vision = isVisionVisible(plan, plan_state)

        const lastEmployeeBulkUpload = new Date(res.data.last_employee_bulk_upload)

        const servicesObject = transformServicesArrayToObj(services)
        dispatch({
          type: SET_SERVICES,
          data: servicesObject
        })

        localStorage.setItem('company', JSON.stringify(res.data))

        dispatch({
          type: SET_COMPANY,
          data: {
            id,
            name,
            industry,
            security_email,
            sender_name,
            sender_email,
            phishing_report_email,
            default_timezone,
            shortname,
            token_expiration,
            legacy_token_expiration,
            metadata,
            bundle_name,
            bundle,
            organization_type,
            onboarding_survey_completed,
            enable_hm_short_demo,
            onboarding_steps_finished,
            created,
            plan,
            plan_state,
            plan_state_expiration_date,
            salesforce_id
          }
        })
        dispatch({
          type: SET_LAST_UPLOAD_DATE,
          data: lastEmployeeBulkUpload
        })
        dispatch({
          type: SET_RECORDS_CHANGED_COUNT,
          data: last_employee_changes_count
        })
        const logindata = await dispatch(whoAmI())
        // Saving the Email of Logged in User in local storage
        localStorage.setItem('loggedInUserEmail', logindata.email)

        registerApps({ ...servicesObject, show_ui_vision, logindata })

        return res.data
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve company info.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function getOrganizationAuthSettings() {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: '/organizations/current_auth_settings/',

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        const { auth_settings } = res.data

        dispatch({
          type: SET_ORG_AUTH_SETTINGS,
          data: auth_settings
        })
        return res.data
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve company auth settings.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function editOrganization(
  {
    name,
    industry,
    security_email,
    sender_name,
    sender_email,
    phishing_report_email,
    default_timezone,
    token_expiration,
    legacy_token_expiration,
    metadata,
    wizard,
    idp_metadata_url,
    onboarding_survey_completed,
    onboarding_steps_finished
  },
  cb,
  showSuccessToast = true
) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'patch',
      url: `/organizations/${orgId}/`,

      headers: {
        Authorization: token
      },
      data: {
        name,
        industry,
        security_email,
        sender_name,
        sender_email,
        phishing_report_email,
        default_timezone,
        token_expiration,
        legacy_token_expiration,
        metadata,
        idp_metadata_url,
        onboarding_survey_completed,
        onboarding_steps_finished
      }
    })
      .then((res) => {
        dispatch(getCompany())
        dispatch({ type: CLEAN_ORG_AUTH_SETTINGS })
        dispatch(getOrganizationAuthSettings())
        dispatch(verifyOrganizationSenderSignature())
        if (!wizard && showSuccessToast) {
          dispatch(
            createMessage(
              {
                type: 'generic',
                level: 'success',
                header: 'Success!',
                content: 'Company info updated.'
              },
              8000
            )
          )
        }
        if (cb) cb(true)
      })
      .catch((err) => {
        const messageData = {
          type: 'generic',
          level: 'danger',
          header: 'Error:'
        }

        messageData.content =
          err.response && err.response.data
            ? err.response.data[Object.keys(err.response.data)[0]]
            : 'Could not update company info.'
        dispatch({
          type: SET_ORG_AUTH_SETTINGS,
          data: { idp_metadata_url }
        })
        dispatch(createMessage(messageData, 8000))
        if (cb) cb(false)
      })
  }
}

export function verifyOrganizationSenderSignature(cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const metadata = getState().get('engagement').orgs.get('company').metadata
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'post',
      url: `/organizations/${orgId}/verify_sender_signature/`,
      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        const { status } = res.data
        dispatch({
          type: SET_ORG_SENDER_SIGNATURE_STATUS,
          data: status
        })
        if (cb) cb(true, status)
      })
      .catch((err) => {
        sendDatadogError('Could not verify sender signature.', 'warning', err.response)
      })
  }
}

export function resendSenderSignatureVerificationEmail(cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const metadata = getState().get('engagement').orgs.get('company').metadata
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'post',
      url: `/organizations/${orgId}/resend_sender_signature/`,
      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        const { status } = res.data
        const message = {
          type: 'generic',
          level: 'success',
          header: 'Success!',
          content: 'Sender signature confirmation was sent!'
        }
        dispatch(createMessage(message, 8000))
        verifyOrganizationSenderSignature(cb)
      })
      .catch((err) => {
        sendDatadogError('Could not resend sender signature.', 'warning', err.response)
      })
  }
}

export function getOrganizationAPIKey() {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch(isLoading(true))

    return axios({
      method: 'get',
      url: '/auth/apikey/',
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        const { api_key } = res.data
        dispatch({
          type: SET_API_KEY,
          data: api_key
        })

        dispatch(isLoading(false))

        return api_key
      })
      .catch((err) => {
        dispatch({
          type: SET_API_KEY,
          data: ''
        })

        dispatch(isLoading(false))

        if (err.response.status === 404) {
          return false // key wasn't created yet
        }
        // the API request failed for another reason
        sendDatadogError('Could not get organization API Key.', 'warning', err.response)
        return null
      })
  }
}

export function generateOrganizationAPIKey() {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch(isLoading(true))

    return axios({
      method: 'post',
      url: '/auth/apikey/',
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        const { api_key } = res.data
        dispatch({
          type: SET_API_KEY,
          data: api_key
        })
        dispatch(isLoading(false))

        return api_key
      })
      .catch((err) => {
        sendDatadogError('Could not create an organization API Key.', 'warning', err.response)
        return null
      })
  }
}

/**
 * Ensures an API Key is created if it hasn't been generated yet (but never regenerate
 *  otherwise - if the GET fails with anything else than 404, don't generate a key
 */
export function ensureOrganizationAPIKey() {
  return async (dispatch, getState) => {
    let key = await dispatch(getOrganizationAPIKey())
    if (key === false) {
      // wasn't created yet
      key = await dispatch(generateOrganizationAPIKey())
    }
    return key
  }
}
// Delete API Key for an organization
export function deleteOrganizationAPIKey(id, name, handler) {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch(isLoading(true))

    return axios({
      method: 'delete',
      url: `/auth/api-key/${id}/`,
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `API key ${name} deleted successfully`
            },
            8000
          )
        )
        dispatch(getOrganizationAPIKeys())
      })
      .catch((err) => {
        sendDatadogError('Could not delete organization API key.', 'warning', err.response)
      })
      .finally(() => {
        dispatch(isLoading(false))
        if (handler) handler(false)
      })
  }
}

// List API keys for an organization
export function getOrganizationAPIKeys() {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: '/auth/api-key/',
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        const { results } = res.data
        dispatch({
          type: SET_API_KEYS,
          data: results
        })
        return results
      })
      .catch((err) => {
        sendDatadogError('Could not get organization API Keys.', 'warning', err.response)
      })
      .finally(() => dispatch(isLoading(false)))
  }
}

// Create API keys for an organization
export function createOrganizationAPIKey(name, expired_at, handler) {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch(isLoading(true))

    return axios({
      method: 'post',
      url: '/auth/api-key/',
      headers: {
        Authorization: token,
        Accept: 'application/json'
      },
      data: {
        name,
        expired_at
      }
    })
      .then((res) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `API Key ${name} created successfully`
            },
            8000
          )
        )
        dispatch(getOrganizationAPIKeys())
      })
      .catch((error) => {
        const errorDetails = error?.response?.data || {}
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content:
                JSON.stringify(errorDetails?.expired_at) ||
                JSON.stringify(errorDetails?.name) ||
                JSON.stringify(errorDetails)
            },
            8000
          )
        )
        sendDatadogError('Could not create an organization api key.', 'warning', error.response)
      })
      .finally(() => {
        dispatch(isLoading(false))
        if (handler) handler(false)
      })
  }
}

// reveal / retrieve API keys for an organization
export function revealOrganizationAPIKey(id) {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch(isLoading(true))

    return axios({
      method: 'get',
      url: `/auth/api-key/${id}/`,
      headers: {
        Authorization: token,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        dispatch({
          type: REVEAL_API_KEY,
          data: res?.data || {}
        })
      })
      .catch((err) => {
        sendDatadogError('Could not reveal an organization API Key.', 'warning', err.response)
        return null
      })
      .finally(() => dispatch(isLoading(false)))
  }
}

export function updateOrganizationAPIKey(id, params, handler) {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch(isLoading(true))
    return axios({
      method: 'patch',
      url: `/auth/api-key/${id}/`,
      headers: {
        Authorization: token,
        Accept: 'application/json'
      },
      data: params
    })
      .then((res) => {
        dispatch({
          type: UPDATE_API_KEY,
          data: res?.data || {}
        })
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `Data is updated`
            },
            8000
          )
        )
        dispatch(getOrganizationAPIKeys())
      })
      .catch((error) => {
        const errorDetails = JSON.stringify(error?.response?.data || {})
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: errorDetails
            },
            8000
          )
        )
        sendDatadogError('Could not update an organization API Key.', 'warning', error.response)
      })
      .finally(() => {
        dispatch(isLoading(false))
        if (handler) handler(false)
      })
  }
}

export function hasBehaviorData() {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/organizations/${orgId}/has_imported_data/`,
      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_HAS_BEHAVIOR_DATA,
          data: res.data.message
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}

/** **************** USERS ***************** */
/**
 * function:: validateEmployeeCsvFile(formData, cb)
 *
 * Queries the backend to perform validation on the headers
 * of the employees CSV, depending on their service level and returns a pre-signed S3 url
 * if the file is valid
 *
 * @param {object} formData
 * @param {string} token
 * @returns {Promise}
 */
export async function validateEmployeeCsvFile(csvHeaders, token, orgId) {
  const options = {
    headers: {
      Authorization: `${token}`,
      'Content-Type': 'application/json'
    }
  }
  return axios
    .post(`/organizations/${orgId}/prepare_employee_upload/`, csvHeaders, options)
    .then((res) => res.data)
}

/**
 * function:: uploadEmployees(formData, cb)
 *
 * Queries the API for a pre-signed S3 URL and the uses this to upload the files to the an S3 bucket.
 *
 * @param {Array(File)} files - An array of files to upload to S3
 * @param {function } cb - Function callback upon success/failure
 */
export function uploadEmployees({ files }, cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    validateExtensionEachFile(files, async (status, message, file) => {
      if (!status) {
        return cb(false, message, file)
      }
      try {
        const { fileData, firstLine } = await readerCsvFile(file)
        const body = {
          csvHeaders: firstLine
        }
        // Query the API for a pre-signed URL
        const presignedData = await validateEmployeeCsvFile(body, token, orgId)
        const response = await uploadIntegrationFile(presignedData, fileData, dispatch)
        if (presignedData && presignedData.polling_url) {
          const pollingUrl = presignedData.polling_url
          getImportStatus(pollingUrl, file.name, dispatch)
        }
        cb(true, response, file)
      } catch (error) {
        console.warn('Error uploading individuals: ', error)
        const response = error.response ? error.response : error
        const hasData = response && response.hasOwnProperty('data')
        if (hasData) {
          cb(false, response, file)
        } else {
          cb(
            false,
            {
              data: { Errors: response }
            },
            file
          )
        }
      }
    })
  }
}

/** Remove once SNAP-267 is active in production */
export function uploadEmployeesLegacy({ files }, cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')
    validateExtensionEachFile(files, (status, message, file) => {
      if (!status) {
        return cb(false, message, file)
      }
      // create a single FormDate for the validated file
      const formData = new FormData()
      formData.append('file', file)

      axios
        .post(`/organizations/${orgId}/upload_employees/`, formData, {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(({ response }) => {
          cb(true, response, file)
          dispatch({
            type: SET_LAST_UPLOAD_DATE,
            data: parseCreatedForUI({ date: new Date() })
          })
          dispatch(searchEmployees())
        })
        .catch(({ response }) => {
          console.warn('Error uploading employees:', response)

          const hasData = response && response.hasOwnProperty('data')
          if (hasData) {
            cb(false, response, file)
          } else {
            cb(false, { data: { Errors: response } }, file)
          }
        })
    })
  }
}

export function searchEmployees(args = {}) {
  return (dispatch, getState) => {
    const organization = getState().get('engagement').orgs.get('company')
    const { id: orgId, organization_type } = organization

    const token = getState().get('engagement').auth.get('JWT')

    const { params, cb } = args

    let paginationQuery = `&limit=25`

    let sortQuery = '&ordering=last_name'

    let searchQuery = ''

    let filterQuery = ''

    let url = '/employees/'
    let method = 'get'
    let data = null

    const excludeElevateEmployeesQuery = '&exclude_internal_admins=true'

    if (params) {
      if (params.search) searchQuery = `&search=${params.search}`

      if (params.sort && params.sort.direction && params.sort.property) {
        const sortDir = params.sort.direction.toString().trim() === 'asc' ? '' : '-'
        sortQuery = `&ordering=${sortDir}${params.sort.property}`
      }

      if (params.pagination) {
        const { limit, offset } = params.pagination
        paginationQuery = `&limit=${limit}&offset=${offset}`
      }

      if (params.filter)
        filterQuery = `&filter=${encodeURIComponent(JSON.stringify(params.filter))}`
    }

    if (filterQuery) {
      url = '/employees/preview/'
      method = 'post'
      data = { filters: `${JSON.stringify(params.filter)}` }
    }

    return axios({
      method,
      url: `${url}?organization=${orgId}&is_active=true${paginationQuery}${searchQuery}${sortQuery}${excludeElevateEmployeesQuery}`,
      headers: {
        Authorization: token
      },
      data
    })
      .then((res) => {
        dispatch({
          type: SET_EMPLOYEE_COUNT,
          data: res.data.count
        })
        dispatch({
          type: SET_EMPLOYEES,
          data: res.data.results
        })
        if (cb)
          cb({
            status: true,
            ...params,
            count: res.data.count,
            employeeCount: res.data.count,
            results: res.data.results
          })
      })
      .catch((error) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve individuals.'
            },
            8000
          )
        )

        if (cb) cb({ status: false, error })
        console.error(error)
      })
  }
}

/** **************** INTEGRATIONS ***************** */

export function getIntegrationStreams() {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch({
      type: INTEGRATION_STREAMS_LOADER,
      data: true
    })

    axios({
      method: 'get',
      url: `/integrations/integration-stream-self-service`,

      headers: {
        Authorization: token
      }
    })
      .then((response) => {
        const integrations = response.data.results
        dispatch({
          type: SET_INTEGRATION_STREAMS,
          data: integrations
            .filter(({ vendor }) => vendor !== null)
            .map((stream) => mapIntegrationStream(stream))
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'We could not get the list of integrations for the org'
            },
            8000
          )
        )
        dispatch({
          type: INTEGRATION_STREAMS_LOADER,
          data: false
        })
        sendDatadogError('Could not retrieve integrations for the org.', 'error', err.response)
      })
  }
}

export function getDatasetsForStream(streamId, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    const default_timezone = getState().get('engagement').orgs.get('company').default_timezone
    axios({
      method: 'get',
      url: `/integrations/integration-stream-self-service/${streamId}/datasets/`,

      headers: {
        Authorization: token
      }
    })
      .then((response) => {
        cb(response.data.results.map((stream) => mapDataset(stream, default_timezone)))
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'We could not get the datasets for this stream'
            },
            8000
          )
        )
        sendDatadogError('Could not retrieve datasets.', 'error', err.response)
      })
  }
}

export function getCredentialsForVendor(vendorCode, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    axios({
      method: 'get',
      url: `/integrations/api-credentials/?integration_vendor__code=${vendorCode}`,

      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data.results.length >= 1) {
          cb(response.data.results[0])
        }
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'We could not get the existing credentials for this vendor'
            },
            8000
          )
        )
        sendDatadogError('Could not retrieve integrations.', 'error', err.response)
      })
  }
}

export function saveAPICredentials(objId, vendorName, data, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    axios({
      method: objId ? 'put' : 'post',
      url: objId ? `/integrations/api-credentials/${objId}/` : `integrations/api-credentials/`,

      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      },
      data
    })
      .then((res) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `Your ${sanitizeContent(vendorName)} data has been successfully integrated.`
            },
            8000
          )
        )
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'Please check your credentials and try again'
            },
            8000
          )
        )
        sendDatadogError('Could not retrieve integrations.', 'error', err.response)
      })
      .finally((res) => {
        if (cb) {
          cb()
        }
      })
  }
}

export function uploadIntegrations(fileData, cb) {
  return (dispatch, getState) => {
    try {
      const orgName = getState().get('engagement').orgs.get('company').shortname
      const token = getState().get('engagement').auth.get('JWT')
      const streamId = fileData.streamId

      // Check to see if user has selected an integration
      if (streamId === null) {
        cb(false, {
          data: {
            Errors: {
              row_errors: [],
              base_errors: ['Please select an integration']
            }
          }
        })
        return
      }

      fileData.files.forEach((file) => {
        const process = uploadingProcessForIntegration(file, orgName, streamId, token, dispatch)
        // call back each file
        process
          .then(({ response }) => cb(true, response, file))
          .catch(({ response }) => {
            console.warn('Error in uploadIntegrations: ', response)
            const hasData = response && response.hasOwnProperty('data')
            if (hasData) {
              cb(false, response, file)
            } else {
              cb(
                false,
                {
                  data: { Errors: response }
                },
                file
              )
            }
          })
      })
    } catch (error) {
      cb(false, {
        data: {
          Errors: {
            row_errors: [],
            base_errors: ['Something went wrong, try again later.']
          }
        }
      })
    }
  }
}

export const downloadValidation = (key, cb) => async (dispatch, getState) => {
  const token = getState().get('engagement').auth.get('JWT')
  await axios({
    method: 'get',
    url: `/integrations/files/?key=${key}`,
    headers: {
      Authorization: token
    }
  })
    .then((res) => {
      setupAutoDownload(res.data.url, key)
      if (cb) cb(res)
    })
    .catch((err) => {
      dispatch(
        createMessage(
          {
            type: 'generic',
            level: 'danger',
            header: 'Error:',
            content: `Could not retrieve validation file: ${sanitizeContent(key)}`
          },
          8000
        )
      )
      if (cb) cb(err)
    })
}

/**
 * Validate the extension each file
 *
 * @export {Function}
 * @param {Array(File)} files
 * @param {function } cb
 */
export function validateExtensionEachFile(files, cb) {
  const ALLOWED_EXTENSIONS = ['csv']

  files.forEach((file) => {
    const fileExt = getFileExt(file)
    const isValidFile = ALLOWED_EXTENSIONS.includes(fileExt)

    if (isValidFile) {
      cb(true, null, file)
    } else {
      console.warn(`File extension ${fileExt} is not valid`)
      cb(
        false,
        {
          data: {
            Errors: {
              row_errors: [],
              base_errors: ['Invalid file extension']
            }
          }
        },
        file
      )
    }
  })
  function getFileExt(file) {
    if (file && file.name) {
      const parts = file.name.split('.')
      return parts[parts.length - 1]
    }
    return null
  }
}

/**
 * The uploadingProcessForIntegration is responsible by start the process
 * which make the reading csv file, tha validation from header file and
 * the upload file for integrations
 *
 * @param {File} file
 * @param {string} orgName
 * @param {string} streamId
 * @param {string} token
 * @param {function} [dispatch=null]
 * @returns {Promise}
 */
async function uploadingProcessForIntegration(file, orgName, streamId, token, dispatch = null) {
  // create the body that will be validated
  const body = {
    fileName: file.name,
    orgName,
    streamId
  }
  const presignedData = await getUploadBucketURL(body, token)
  const response = await uploadIntegrationFile(presignedData, file, dispatch)

  return response
}
/**
 * The readerCsvFile is responsible to read the csv file
 * and return the first line and the file stream in a resolved promise
 *
 * @param {File} file
 * @returns {Promise}
 */
export async function readerCsvFile(file) {
  return new Promise((resolve, reject) => {
    let error = {}
    try {
      // We need to pull the data from the first line of the csv file
      const reader = new window.FileReader()
      reader.readAsText(file)
      reader.onloadend = () => {
        const fileDataResult = reader.result
        // Trim unused last line if present
        const fileData = fileDataResult.trim()
        const firstLine = fileData.split('\n').shift()
        const response = { firstLine, fileData }
        resolve(response)
      }

      reader.onerror = (e) => {
        error = {
          data: {
            Errors: {
              row_errors: [],
              base_errors: [e]
            }
          }
        }
        reject(error)
      }
    } catch ({ message }) {
      error = {
        data: {
          Errors: {
            row_errors: [],
            base_errors: [message]
          }
        }
      }
      reject(error)
    }
  })
}
/**
 * The getUploadBucketURL is responsible to get S3 bucket URL
 *
 * @param {object} formData
 * @param {string} token
 * @returns {Promise}
 */
async function getUploadBucketURL(formData, token) {
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json'
    }
  }
  return axios.post(`/integrations/validate/`, formData, options).then((res) => res.data)
}

/** *
 * The uploadIntegrationFile is responsible by to send the
 * csv file to aws
 *
 * @param {string} presignedData {data generated by getUploadBucketURL}
 * @param {string/arrayBuffer} fileData {The stream generated by readerCsvFile}
 * @param {function} dispatch {The function to dispatch state to redux}
 * @returns {Promise}
 */
async function uploadIntegrationFile(presignedData, fileData, dispatch = null) {
  const signedUrl = decodeURI(presignedData.url)
  const options = {
    headers: presignedData.headers,
    withCredentials: false,
    onUploadProgress: (progressEvent) => {
      if (dispatch) {
        dispatch({
          type: SET_S3_UPLOAD_PROGRESS,
          data: progressEvent
        })
      }
    }
  }
  return axios.put(signedUrl, fileData, options)
}

/** *
 * The getImportStatus is responsible for getting the import status
 * of a file upload
 *
 * @param {string} pollingUrl {The url to poll to get import status}
 * @param {string} filename {The name of the file imported}
 * @param {function} dispatch {The function to dispatch state to redux}
 * @returns {Promise}
 */
async function getImportStatus(pollingUrl, filename, dispatch) {
  const startTime = new Date()
  async function executeGetStatus(resolve, reject) {
    if (new Date() - startTime >= 10 * 60 * 1000) {
      const messageData = {
        type: 'generic',
        header: null,
        level: 'warning',
        content: `We're still importing your file ${sanitizeContent(
          filename
        )}, you will receive a report by email once we have processed your data`
      }
      return reject(dispatch(createMessage(messageData, 8000)))
    }
    try {
      const result = await axios.get(decodeURI(pollingUrl), { withCredentials: false })
      let importStatus = ''
      if (result.data) {
        parseString(result.data, (err, parse_result) => {
          if (parse_result.Tagging.TagSet[0]) {
            const tagSet = parse_result.Tagging.TagSet[0].Tag
            tagSet.forEach((element) => {
              if (element && element.Key[0] && element.Key[0] === 'IMPORT_STATUS')
                importStatus = element.Value[0].toLowerCase()
            })
          }
        })
      }
      if (importStatus) {
        const messageData = {
          type: 'generic',
          header: null
        }
        switch (importStatus) {
          case 'success':
            dispatch(getSimpleEmployees())
            messageData.level = 'success'
            messageData.content = `We’ve successfully processed your file ${sanitizeContent(
              filename
            )}.`
            break
          case 'success_with_invalid_rows':
            dispatch(getSimpleEmployees())
            messageData.level = 'warning'
            messageData.content =
              `We’ve finished processing your file ${sanitizeContent(filename)}, ` +
              `but some rows were ignored due to errors. We’ve sent a report by email. ` +
              `Please contact Support if you are unsure how to correct the data.`
            break
          case 'invalid':
            messageData.level = 'danger'
            messageData.content =
              `We’ve processed your file ${sanitizeContent(filename)} but we could not extract ` +
              `valid data from it. We’ve sent a report by email. Please contact ` +
              `Support if you are unsure how to correct the data.`
            break
          case 'failed':
            messageData.level = 'danger'
            messageData.content =
              `An error occurred while we were processing your file ${sanitizeContent(
                filename
              )}. ` +
              `We will keep trying and you will receive a report by email ` +
              `once it is fully processed. Feel free to try again with a different file, ` +
              `or contact Support if you do not receive a confirmation email.`
            break
          default:
            // Retry - import is still in progress
            setTimeout(executeGetStatus, 1000, resolve, reject)
            return
        }
        dispatch(createMessage(messageData, 12000, true))

        return resolve(result)
      }
    } catch (error) {
      // Send error to datadog and retry if error in axios.get
      sendDatadogError(`Could not retrieve import status`, 'error', error)
      setTimeout(executeGetStatus, 1000, resolve, reject)
    }
    // Retry every second
    setTimeout(executeGetStatus, 1000, resolve, reject)
  }
  return new Promise(executeGetStatus)
}

/** **************** CAMPAIGNS ***************** */
export function getCampaigns(args = {}) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')
    const { cb, filter } = args

    return axios({
      method: 'get',
      url: `/hackersmindcampaigns/?organization=${orgId}&deleted=false&ordering=-created&${
        filter || ''
      }`,

      headers: {
        Authorization: token
      }
    })
      .then(
        (res) => {
          const results = res.data.results.map((campaign) => {
            campaign.ui_created = parseCreatedForUI({
              date: new Date(campaign.created),
              time: true
            })
            campaign.ui_start_date = parseDateForUI({
              date: new Date(campaign.start_date),
              timezone: campaign.timezone,
              time: true
            })
            campaign.ui_end_date = campaign.end_date
              ? parseDateForUI({
                  date: new Date(campaign.end_date),
                  timezone: campaign.timezone,
                  time: true
                })
              : 'N/A'
            return campaign
          })
          res.data.results = results
          dispatch({
            type: SET_CAMPAIGNS,
            data: res.data
          })
          if (cb) cb()
        },
        (err) => sendDatadogError('could not get campaigns', 'error', err.response)
      )
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve campaigns.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function getCampaign({ id }, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'GET',
      url: `/hackersmindcampaigns/${id}/`,
      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_CAMPAIGN_INFO,
          data: res.data
        })
        if (cb) cb(true)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not get campaing info.'
            },
            8000
          )
        )
        console.error(err)
        if (cb) cb(false)
      })
  }
}

export function editCampaign(
  {
    id,
    name,
    start_date,
    end_date,
    timezone,
    predefined_leaders,
    group,
    update_targets,
    leader_template,
    participant_template,
    tags,
    language,
    status
  },
  cb
) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')
    const campaigns = getState().get('engagement').campaigns.get('campaigns')

    const campaign = campaigns.find((campaign) => (campaign.id = id))

    const data = {
      name,
      start_date,
      end_date,
      group,
      update_targets,
      leader_template,
      language,
      participant_template,
      timezone,
      predefined_leaders: predefined_leaders || campaign.leads,
      organization: orgId,
      tags: tags || campaign.tags,
      status: status || campaign.status
    }

    return axios({
      method: 'patch',
      url: `/hackersmindcampaigns/${id}/`,

      headers: {
        Authorization: token
      },
      data
    })
      .then((res) => {
        dispatch(getCampaigns())
        dispatch(getCampaignTargets(id))
        if (cb) cb(true)
      })
      .catch((err) => {
        const messageData = {
          type: 'generic',
          level: 'danger',
          header: 'Error:'
        }

        messageData.content =
          err.response && err.response.data
            ? err.response.data[Object.keys(err.response.data)[0]]
            : 'Could not edit campaign.'

        dispatch(createMessage(messageData, 8000))
        if (cb) cb(false)
      })
  }
}

export function editCampaignUpdateTargets({ id, update_targets }, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    const data = {
      update_targets
    }
    return axios({
      method: 'patch',
      url: `/hackersmindcampaigns/${id}/`,

      headers: {
        Authorization: token
      },
      data
    })
      .then(() => {
        if (cb) {
          cb(true)
        }
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not save campaign targets.'
            },
            8000
          )
        )
        console.error(err)
        if (cb) cb(false)
      })
  }
}

export function getCampaignTargets(campaignId, cb) {
  return (dispatch, getState) => {
    if (!campaignId) return

    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/hackersmindcampaigns/${campaignId}/targets/?organization=${orgId}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_CAMPAIGN_TARGETS,
          campaignId,
          data: res.data
        })
        if (cb) cb()
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve targets for this campaign.'
            },
            8000
          )
        )
      })
  }
}
export function uploadRooms({ file, campaignId, cb }) {
  return (dispatch, getState) => {
    const formData = new FormData()
    formData.append(`file`, file)
    const token = getState().get('engagement').auth.get('JWT')

    axios
      .post(`/hackersmindcampaigns/${campaignId}/upload_scheduled_sessions/`, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        dispatch(searchRooms({ campaignId, cb: () => cb(true, res, file) }))
      })
      .catch((err) => {
        cb(false, err.response, file)
      })
  }
}
export function searchRooms(args = {}) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    const { params, cb, campaignId } = args

    let paginationQuery = `&limit=25`

    let sortQuery = '&ordering=start_time'

    let searchQuery = ''

    let filterQuery = ''

    if (params) {
      if (params.search) searchQuery = `&search=${params.search}`

      if (params.sort) {
        const sortDir = params.sort.direction === 'asc' ? '' : '-'
        sortQuery = `&ordering=${sortDir}${params.sort.property}`
      }

      if (params.pagination) {
        const { limit, offset } = params.pagination
        paginationQuery = `&limit=${limit}&offset=${offset}`
      }

      if (params.filter)
        filterQuery = Object.keys(params.filter).reduce(
          (acc, key) => `${acc}&${key}=${params.filter[key]}`,
          ''
        )
    }

    return axios({
      method: 'get',
      url: `/hackersmindscheduledsessions/?organization=${orgId}&campaign=${campaignId}${paginationQuery}${searchQuery}${sortQuery}${filterQuery}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_CAMPAIGN_ROOMS,
          campaignId,
          data: {
            results: res.data.results,
            count: res.data.count,
            type: 'search'
          }
        })
        if (cb) cb(params, res.data.count)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve rooms.'
            },
            8000
          )
        )
        console.error(err)
        if (cb) cb(false)
      })
  }
}

export function addRooms({ roomDataArray, campaignId, cb }) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    const data = roomDataArray.map((roomData) => ({
      ...roomData,
      organization: orgId,
      campaign: campaignId
    }))

    return axios({
      method: 'post',
      url: `/hackersmindscheduledsessions/`,

      headers: {
        Authorization: token
      },
      data
    })
      .then((res) => {
        dispatch(searchRooms({ campaignId }))
        if (cb) cb(res.data)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not add room.'
            },
            8000
          )
        )
        console.error(err)
        if (cb) cb(false)
      })
  }
}

export function deleteRooms({ campaignId, roomIdsArray, cb }) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    const roomIdsString = `["`.concat(roomIdsArray.join(`", "`), `"]`)

    return axios({
      method: 'delete',
      url: `/hackersmindscheduledsessions/?organization=${orgId}&filter={"id__in":${roomIdsString}}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch(searchRooms({ campaignId }))
        if (cb) cb(true)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not delete room.'
            },
            8000
          )
        )
        console.error(err)
        if (cb) cb(false)
      })
  }
}

export function editRooms({ campaignId, roomDataArray, cb }) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'patch',
      url: `/hackersmindscheduledsessions/?organization=${orgId}`,

      headers: {
        Authorization: token
      },
      data: roomDataArray
    })
      .then((res) => {
        dispatch(searchRooms({ campaignId }))
        if (cb) cb(res.data)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not edit room.'
            },
            8000
          )
        )
        console.error(err)
        if (cb) cb(false)
      })
  }
}

/** **************** TEMPLATES ***************** */
export function getEmailTemplates() {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/templates/?organization=${orgId}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_TEMPLATES,
          data: res.data.results
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve email templates.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function createEmailTemplate({ name, subject, body, key }, cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const shortname = getState().get('engagement').orgs.get('company').shortname
    const token = getState().get('engagement').auth.get('JWT')

    body = body.replace(/(\r\n\t|\n|\r\t)/gm, '')

    return axios({
      method: 'post',
      url: `/templates/?organization=${orgId}/`,

      headers: {
        Authorization: token
      },
      data: {
        name,
        subject,
        body,
        key: shortname.concat('_', key),
        organization: orgId
      }
    })
      .then((res) => {
        dispatch(getEmailTemplates())
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `${sanitizeContent(res.data.name)} template updated.`
            },
            8000
          )
        )
        if (cb) cb()
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'error',
              header: 'Error:',
              content: `Could not update template.`
            },
            8000
          )
        )
      })
  }
}

export function editEmailTemplate({ id: currentEmailId, name, subject, body, key, isDefault }, cb) {
  return (dispatch, getState) => {
    if (isDefault) dispatch(createEmailTemplate({ name, subject, body, key }, cb))
    else {
      const token = getState().get('engagement').auth.get('JWT')

      body = body.replace(/(\r\n\t|\n|\r\t)/gm, '')

      return axios({
        method: 'patch',
        url: `/templates/${currentEmailId}/`,

        headers: {
          Authorization: token
        },
        data: { name, subject, body }
      })
        .then((res) => {
          dispatch(getEmailTemplates())
          dispatch(
            createMessage(
              {
                type: 'generic',
                level: 'success',
                header: 'Success!',
                content: `${sanitizeContent(res.data.name)} template updated.`
              },
              8000
            )
          )
          if (cb) cb()
        })
        .catch((err) => {
          console.error(err)
          dispatch(
            createMessage(
              {
                type: 'generic',
                level: 'error',
                header: 'Error:',
                content: `Could not update template.`
              },
              8000
            )
          )
        })
    }
  }
}

export function sendPreviewEmail(
  subject,
  { body = '', content = {}, campaign = null, consumable = null, template = null }
) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    const orgId = getState().get('engagement').orgs.get('company').id

    /* Use mails API to send an example email, recipient cannot be customized */
    const data = {
      subject,
      body,
      organization: orgId,
      campaign,
      consumable,
      template,
      context: content
    }

    return axios({
      method: 'post',
      url: `/mails/`,

      headers: {
        Authorization: token
      },
      data
    })
      .then((res) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: 'Check your inbox to preview this email template.'
            },
            8000
          )
        )
      })
      .catch((err) => {
        console.error(err)
      })
  }
}

export function sendTestEmail(subject, body) {
  return (dispatch, getState) => {
    const company = getState().get('engagement').orgs.get('company')
    const me = getState().get('engagement').admin.get('me')
    const data = {
      body,
      content: {
        ...me,
        ...company
      }
    }
    dispatch(sendPreviewEmail(subject, data))
  }
}

/** GET GROUP TYPE HELPER */
function getGroupType(group_category, group_type) {
  if (group_category) return GROUP_CATEGORIES[group_category]
  if (group_type) return GROUP_TYPES[group_type]
  return null
}

/** **************** GROUPS ***************** */
export function clearGroups() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_GROUPS
    })
  }
}

export function getGroups(
  group_category,
  group_type,
  searchVal,
  limit = 25,
  page = 0,
  groupIds = null
) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')
    dispatch({
      type: GROUPS_LOADED,
      isLoaded: false
    })

    const params = {
      limit,
      offset: limit * page,
      group_category__in: group_category,
      group_type__in: group_type,
      name__icontains: searchVal
    }

    if (groupIds) {
      params['id__in'] = groupIds
    }

    return axios({
      method: 'get',
      url: `/groups/?organization=${orgId}`,
      params,
      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        const results = res.data.results
          .filter((group) => !group.deleted)
          .map((group) => {
            group.ui_created = parseCreatedForUI({
              date: new Date(group.created)
            })
            return group
          })
        res.data.results = results
        dispatch({
          type: SET_GROUPS,
          data: res.data,
          group: getGroupType(group_category, group_type)
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve groups.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function getGroup(groupId, cb = () => {}) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/groups/${groupId}/?organization=${orgId}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        const group = res.data
        group.ui_created = parseCreatedForUI({ date: new Date(group.created) })
        dispatch({
          type: SET_GROUP,
          data: group
        })
        if (cb) return cb(group)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve group.'
            },
            8000,
            true
          )
        )
        console.error(err)
      })
  }
}

const GroupTypeEnum = {
  STATIC: 1,
  DYNAMIC: 2,
  CRITERIA_FILLED: 3,
  CRITERIA_FILLED_R3: 5
}

export const GroupTypeMapping = {
  static: GroupTypeEnum.STATIC,
  criteria_filled: GroupTypeEnum.CRITERIA_FILLED,
  dynamic: GroupTypeEnum.DYNAMIC,
  criteria_filled_r3: GroupTypeEnum.CRITERIA_FILLED_R3
}

export function createGroupV2(params, cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    const data = Object.assign(params, {
      is_dynamic: false,
      organization: orgId
    })

    return axios({
      method: 'post',
      url: `/groups/?organization=${orgId}`,

      headers: {
        Authorization: token
      },
      data
    })
      .then((res) => {
        dispatch({
          type: SET_GROUP,
          data: res.data
        })
        dispatch(getGroups())
        if (cb) cb(res.data.id)
      })
      .catch((err) => {
        let error_msg = 'Could not create group.'
        if (err?.response?.data?.non_field_errors) {
          const errors = err.response.data.non_field_errors
          error_msg = errors.join('\n')
        }
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: sanitizeContent(error_msg)
            },
            8000,
            true
          )
        )
        if (cb) cb(false)
        console.error(err)
      })
  }
}

export function editGroupV2(id, params, cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    const data = Object.assign(params, {
      is_dynamic: false,
      organization: orgId
    })

    return axios({
      method: 'patch',
      url: `/groups/${id}/?organization=${orgId}`,

      headers: {
        Authorization: token
      },
      data
    })
      .then((res) => {
        const group = res.data
        group.ui_created = parseCreatedForUI({ date: new Date(group.created) })

        dispatch({
          type: UPDATE_GROUP,
          groupId: id,
          data: group
        })
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `Group ${sanitizeContent(res.data.name)} updated.`
            },
            8000,
            true
          )
        )
        if (cb) cb(true)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Group could not be updated.'
            },
            8000,
            true
          )
        )
        if (cb) cb(false)
        console.error(err)
      })
  }
}

export function getGroupMembersFilters(groupId) {
  return (dispatch, getState) => {
    if (!groupId) return

    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/groups/${groupId}/members_filters/`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_GROUP_MEMBERS_FILTERS,
          groupId,
          data: res.data
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve filters for the group.'
            },
            8000,
            true
          )
        )
        console.error(err)
      })
  }
}

export function getGroupPolicyData(groupId, policyIds) {
  return (dispatch, getState) => {
    if (!policyIds) return

    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_SERVER_BASE_URL}/reputations/policies/name`,
      params: {
        policy_ids: policyIds.join(',')
      },
      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_GROUP_POLICY_DATA,
          groupId,
          data: res.data
        })
        dispatch({
          type: SET_GROUP_MEMBERSHIP_DATA,
          groupId,
          data: res.data
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve members for this group.'
            },
            8000,
            true
          )
        )
        console.error(err)
      })
  }
}

export function syncGroupMembers(groupId, token) {
  return axios({
    method: 'get',
    url: `/groups/${groupId}/sync_members/`,
    headers: {
      Authorization: token
    }
  })
}

export function getGroupMembersV2({ groupId, params }) {
  return (dispatch, getState) => {
    if (!groupId) return

    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'get',
      url: `/groups/${groupId}/members/?${new URLSearchParams(params).toString()}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_GROUP_MEMBERS,
          groupId,
          data: res.data
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve members for this group.'
            },
            8000,
            true
          )
        )
        console.error(err)
      })
  }
}

export function getGroupMembershipLogs({ groupId, params: extraParams = {} }) {
  return (dispatch, getState) => {
    if (!groupId) return

    const token = getState().get('engagement').auth.get('JWT')
    const orgId = getState().get('engagement').orgs.get('company').id

    return axios({
      method: 'get',
      url: `/group_membership_logs/`,
      headers: {
        Authorization: token
      },
      params: {
        organization: orgId,
        group: groupId,
        ...extraParams
      }
    })
      .then((res) => {
        dispatch({
          type: SET_GROUP_MEMBERSHIP_LOGS,
          groupId,
          data: res.data
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve membership logs for this group.'
            },
            8000,
            true
          )
        )
        console.error(err)
      })
  }
}

export function createGroup({ name, members, is_dynamic }, cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    const data = {
      name,
      is_dynamic,
      organization: orgId,
      group_type: is_dynamic ? GroupTypeEnum.DYNAMIC : GroupTypeEnum.STATIC
    }

    const isDynamicFilteredGroup = Array.isArray(members) && Array.isArray(members[0])
    if (!isDynamicFilteredGroup) {
      data['_members'] = members
      data['filter_query'] = null
    } else {
      data['_members'] = []
      data['filter_query'] = members
    }

    return axios({
      method: 'post',
      url: `/groups/?organization=${orgId}`,

      headers: {
        Authorization: token
      },
      data
    })
      .then((res) => {
        dispatch({
          type: SET_GROUP,
          data: res.data
        })
        dispatch(getGroups())
        if (cb) cb(res.data.id)
      })
      .catch((err) => {
        let error_msg = 'Could not create group.'
        if (err?.response?.data?.non_field_errors) {
          const errors = err.response.data.non_field_errors
          error_msg = errors.join('\n')
        }
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: sanitizeContent(error_msg)
            },
            8000,
            true
          )
        )
        if (cb) cb(false)
        console.error(err)
      })
  }
}

export function editGroup(id, { name, members, is_dynamic }, cb) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    const data = {
      name,
      is_dynamic,
      organization: orgId,
      group_type: is_dynamic ? GroupTypeEnum.DYNAMIC : GroupTypeEnum.STATIC
    }

    const isDynamicFilteredGroup = Array.isArray(members) && Array.isArray(members[0])
    if (!isDynamicFilteredGroup) {
      data['_members'] = members
      data['filter_query'] = null
    } else if (is_dynamic) {
      data['_members'] = []
      data['filter_query'] = members
    }

    return axios({
      method: 'patch',
      url: `/groups/${id}/?organization=${orgId}`,

      headers: {
        Authorization: token
      },
      data
    })
      .then((res) => {
        const group = res.data
        group.ui_created = parseCreatedForUI({ date: new Date(group.created) })

        dispatch({
          type: UPDATE_GROUP,
          groupId: id,
          data: group
        })
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `Group ${sanitizeContent(res.data.name)} updated.`
            },
            8000,
            true
          )
        )
        if (cb) cb(true)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Group could not be updated.'
            },
            8000,
            true
          )
        )
        if (cb) cb(false)
        console.error(err)
      })
  }
}

export function deleteGroup(groupId, name = undefined, cb = undefined) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    return axios({
      method: 'delete',
      url: `/groups/${groupId}/`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: DELETE_GROUP,
          groupId,
          data: res.data
        })

        if (cb) cb(true, { groupId, data: res.data })

        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: sanitizeContent(name) || 'Success!',
              content: 'group successfully deleted.'
            },
            8000,
            true
          )
        )
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not delete group.'
            },
            8000,
            true
          )
        )
        if (cb) cb(false, err)
        console.error(err)
      })
  }
}

export function getGroupMembers({ groupId, params, cb }) {
  return (dispatch, getState) => {
    if (!groupId) return

    const token = getState().get('engagement').auth.get('JWT')

    let paginationQuery = `&limit=25`
    if (params && params.pagination) {
      const { limit, offset } = params.pagination
      paginationQuery = `&limit=${limit}&offset=${offset}`
    }

    return axios({
      method: 'get',
      url: `/groups/${groupId}/members/?${paginationQuery}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_GROUP_MEMBERS,
          groupId,
          data: res.data
        })
        if (cb) cb(res.data)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve members for this group.'
            },
            8000,
            true
          )
        )
        console.error(err)
      })
  }
}
export function getPreferredLanguages(cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    const orgId = getState().get('engagement').orgs.get('company').id
    axios({
      method: 'get',
      url: `/organizations/${orgId}/get_preferred_languages/`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_PREFERRED_LANGUAGES,
          data: res.data
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve preferred languages.'
            },
            8000,
            true
          )
        )
        sendDatadogError('Could not retrieve languages.', 'error', err.response)
      })
  }
}

export function getGroupsAvailableFilters() {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch({
      type: LOADING_GROUPS_FILTERS,
      isLoadingAvailableFilters: true
    })

    return axios({
      method: 'get',
      url: 'groups/filter_options/',
      headers: {
        Authorization: token
      }
    })
      .then(({ data }) => {
        const copy = { ...data }
        Object.keys(copy)?.forEach((key) => {
          copy[key] = copy[key]?.map((item) => ({
            ...item,
            label: groupTypeLabelMap[item.label] || item.label
          }))
        })
        dispatch({
          type: SET_AVAILABLE_FILTERS,
          data: copy
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve groups filters'
            },
            8000,
            true
          )
        )
        console.error(err)
      })
  }
}

/** **************** MESSAGES ***************** */
export function createMessage(message, expiration = 0, autoExpire) {
  return (dispatch, getState) => {
    const {
      type = 'generic',
      level = 'warning',
      header = '',
      content = '',
      code = '',
      // to reintroduce expiring messages, set the below variable confirmAction to null
      confirmAction = (messageId) => this.props.deleteMessage(messageId)
    } = message

    let messageState = getState().get('engagement').messages || {}
    messageState = messageState.toJS()

    const targetMsg = messageState?.messages?.find((msg) => msg.code === message.code)
    if (targetMsg) return

    const id = generateUUID()

    dispatch({
      type: NEW_MESSAGE,
      data: { id, type, level, header, content, code, confirmAction }
    })
    if ((!confirmAction || autoExpire) && expiration)
      setTimeout(() => dispatch(deleteMessage(id)), expiration)
  }
}

export function deleteMessage(messageId) {
  return (dispatch, getState) => {
    dispatch({
      type: EXPIRE_MESSAGE,
      data: messageId
    })
  }
}

export function deleteAllMessage() {
  return (dispatch, getState) => {
    dispatch({
      type: CLEAR_ALL_MESSAGE
    })
  }
}

export function filterOutMessages(code) {
  return (dispatch, getState) => {
    dispatch({
      type: FILTER_MESSAGE,
      code
    })
  }
}

/** **************** TYPEAHEAD ***************** */
export function fetchEmployees(search, id, extra_filter) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    const url = `/employees/?organization=${orgId}&is_active=true&${extra_filter}`

    dispatch({
      type: SET_TYPEAHEAD_LOADING,
      id
    })

    return axios({
      method: 'get',
      url: `${url}&search=${search}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_TYPEAHEAD_RESULTS,
          id,
          data: res.data.results
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not search individuals.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function GroupFilterTypeahead(filter, id) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    dispatch({
      type: SET_TYPEAHEAD_LOADING,
      id
    })

    const filterQuery = `&filter=${encodeURIComponent(JSON.stringify(filter))}`

    return axios({
      method: 'get',
      url: `/employees/?organization=${orgId}&is_active=true${filterQuery}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_TYPEAHEAD_RESULTS,
          id,
          data: res.data.results
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not search individuals.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function CampaignTypeahead({ search, id }) {
  return (dispatch, getState) => {
    const orgId = getState().get('engagement').orgs.get('company').id
    const token = getState().get('engagement').auth.get('JWT')

    dispatch({
      type: SET_TYPEAHEAD_LOADING,
      id
    })

    return axios({
      method: 'get',
      url: `/hackersmindcampaigns/?organization=${orgId}&deleted=false&ordering=-created&search=${search}`,

      headers: {
        Authorization: token
      }
    })
      .then((res) => {
        dispatch({
          type: SET_TYPEAHEAD_RESULTS,
          id,
          data: res.data.results
        })
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not search campaigns.'
            },
            8000
          )
        )
        console.error(err)
      })
  }
}

export function initTypeahead(id) {
  return (dispatch, getState) => {
    dispatch({
      type: INIT_TYPEAHEAD,
      id
    })
  }
}
export function setupAutoDownload(url, fileName) {
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('id', `download-${fileName}`)
  link.setAttribute('download', `${fileName}`)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// onboarding actions

export { checkOrgHasScores, loadOnboardingChecks, setCompletedStep, checkOrgHasCampaigns }
